<script setup lang="ts">
import adminAPI from '@/services/api';
import { copyToClipboard } from '@/utils';
import { computed, defineProps, ref, toRefs, watch } from 'vue';
import BaseButton from '../ui/buttons/BaseButton.vue';
import { ArrowTopRightOnSquareIcon, ClipboardDocumentCheckIcon } from '@heroicons/vue/24/solid';
import BaseLoader from '@/components/ui/loaders/BaseLoader.vue';
import DividerCenterMedium from "@/components/ui/dividers/DividerCenterMedium.vue"
import { computedAsync } from '@vueuse/core';
import BoxFileUploader from '@/components/Box/BoxFileUploader.vue';
import { BoxFileRequestLink, BoxPublicLink } from '@/interfaces';

const props = defineProps<{ claimId: string }>()
const { claimId } = toRefs(props);

const boxThirdUploadFolder = ref<BoxPublicLink>();
watch(claimId, async (id) => {
  boxThirdUploadFolder.value = await adminAPI.getReceivablesBoxFolder(id)
}, { immediate: true })

const publicDocumentsUrl = computed(() => boxThirdUploadFolder.value?.publicLink);


const fileUploadResponse = ref<BoxFileRequestLink>();
watch(claimId, async (id) => {
  fileUploadResponse.value = await adminAPI.getFileUploadUrl(id)
}, { immediate: true });
const fileUploadUrl = computed(() => fileUploadResponse.value?.href);

function copyBoxData() {
  // The text should stay in sync with the HTML
  copyToClipboard(`Documents à signer :
${publicDocumentsUrl.value || ''}\n
Lien pour nous transmettre les documents :
${fileUploadUrl.value || ''}`);
}

function openLink(link?: string) {
  if (link) {
    window.open(link, '_blank');
  }
};
</script>
<template>
<div>
  <div>
    <DividerCenterMedium text="Nous envoyer une signature" />
    <div class="max-w-2xl mx-auto mt-8" v-if="boxThirdUploadFolder?.boxFolderId">
      <BoxFileUploader :folderId="boxThirdUploadFolder.boxFolderId" :accessToken="boxThirdUploadFolder.uploadToken" />
      <p class="z-50 px-2 mt-2 text-base italic text-center">Et tout autre document : Carte d'identité, billet, etc.</p>
    </div>
    <div v-else class="mx-auto mt-10">
      <BaseLoader />
    </div>
    <!-- <div class="mx-auto">
      <iframe v-if="fileUploadUrl" class="w-full mx-auto overflow-hidden rounded-xl" :src="fileUploadUrl" height="700" scrolling="no"></iframe>
      <div v-else class="mx-auto mt-10">
        <BaseLoader />
      </div>
    </div> -->
  </div>
  <div class="mt-16">
    <div class="mb-6">
      <DividerCenterMedium text="Liens partageables" />
    </div>
    <div id="box-copy-content" class="p-5 mb-8 overflow-hidden text-sm font-normal truncate border rounded-lg shadow text-ellipsis bg-gray-50">
      <p>Document à signer :
        <a class="block truncate link" :href="publicDocumentsUrl || '#'" target="_blank">
          {{ publicDocumentsUrl || "Chargement..." }}
        </a>
      </p>
      <p class="mt-6">
        Pour nous transmettre une signature :
        <a class="block truncate link" :href="fileUploadUrl || '#'" target="_blank">
          {{ fileUploadUrl || "Chargement..." }}
        </a>
      </p>
      <div class="inline-flex mt-4 gap-x-6">
        <BaseButton :disabled="!Boolean(publicDocumentsUrl)" :icon="ArrowTopRightOnSquareIcon" text="Voir les documents" @click="openLink(publicDocumentsUrl)" />
        <BaseButton :disabled="!Boolean(fileUploadUrl)" :icon="ClipboardDocumentCheckIcon" text="Copier ce texte" @click="copyBoxData" />
      </div>
    </div>
  </div>
</div>
</template>
<style>
.group-title-container {
  display: none;
}
</style>